import { get } from '@namespace/helpers';

type ReturnType = {
  data: { message?: string; spinAt?: Date };
  status: 'success' | 'error';
};

export const checkSpinWheel = (currency: string) =>
  get<ReturnType>(
    `/service/wheel-of-fortune/wheel-of-fortune/v1/check?currency=${currency}`
  )
    .then((res) => {
      return res;
    })
    .catch((e: ReturnType) => {
      return e;
    });
